import { hasAnyGenre } from "../utils";
import type { Movie, MovieFilterOptions } from "../types";

const filterAndUniqueMovies = (movies: Movie[], { selectedCinema = null, selectedGenres = [] }: MovieFilterOptions): Movie[] => {
  const alreadyIncludedInFinalList = new Set<number>();

  return movies.filter((movie) => {
    if (alreadyIncludedInFinalList.has(movie.movie_id)) return false;

    if (selectedCinema && movie.cinema_id !== selectedCinema.cinema_id) {
      return false;
    }
    if (selectedGenres.length > 0) {
      if (movie.genres.length === 0) return false; //if movie doesnt have any genre, it's discarded directly

      const genreFound = hasAnyGenre(movie, selectedGenres);
      if (!genreFound) return false;
    }

    alreadyIncludedInFinalList.add(movie.movie_id);
    return true;
  });
};

export default filterAndUniqueMovies;